var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTenbisCredit = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 24,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F36805",
  d: "M0 4a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  clipPath: "url(#tenbisCredit_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m14.165 8.408.248-.618c.146-.314.426-.564.78-.695.353-.13.75-.131 1.104-.003l3.554 1.316zM13.553 15.343a.4.4 0 0 0 .263-.097.31.31 0 0 0 .109-.234v-2.645a.28.28 0 0 0-.066-.176.35.35 0 0 0-.12-.107.4.4 0 0 0-.161-.047h-2.943v-1.242c0-.34.153-.668.424-.909s.64-.376 1.023-.376h8.471c.216-.008.43.027.629.102.169.074.32.177.443.303q.186.192.276.432c.067.142.1.294.099.448v5.878c-.002.34-.155.666-.426.907a1.55 1.55 0 0 1-1.02.378h-8.472a1.55 1.55 0 0 1-1.02-.378 1.23 1.23 0 0 1-.427-.907v-1.33z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.685 13.139v1.095H9.834v-1.095zM11.48 7.013q.253-.253.552-.445c.195-.125.195-.464 0-.59a3.3 3.3 0 0 1-.998-.997c-.125-.195-.464-.195-.589 0a3.3 3.3 0 0 1-.998.998c-.195.125-.195.464 0 .59a3.3 3.3 0 0 1 .998.997c.125.195.464.195.59 0q.191-.3.444-.553M8.631 4.631q.158-.158.346-.278c.121-.078.121-.29 0-.368a2.1 2.1 0 0 1-.624-.624c-.078-.122-.29-.122-.368 0a2.1 2.1 0 0 1-.624.624c-.122.078-.122.29 0 .368a2.1 2.1 0 0 1 .624.624c.078.121.29.121.368 0q.12-.187.278-.346"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "tenbisCredit_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7 3h15v15H7z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTenbisCredit);
export default ForwardRef;